import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { PHNUMBER, PURCHASE_TYPE, SESSION_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Modal from '../../../molecules/Modal';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ButtonComp } from '../../../atoms/Buttons';
import {
  getGiftCardDetails,
  resetGiftcardCheckBal,
} from '@kfc-global/react-shared/redux/Actions/GiftCheckBalanceAction';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { useHistory } from 'react-router-dom';
import { redirectToPaymentFailurePage } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const isValidPhoneNumber = (phoneNoText, phoneNumberRegex) => {
  return RegExp(phoneNumberRegex).test(phoneNoText);
};

export const errorStyleForMaterialTextInput = error => {
  return error ? 'text-danger-phoneNumber' : ' ';
};
export const updateUserDetails = (event, phoneNumberState, setPhoneNumberState, phoneNumberRegex) => {
  const inputValue = event.target.value;
  const inputName = event.target.name;
  inputName === PHNUMBER &&
    setPhoneNumberState({
      ...getPhoneNumberData(phoneNumberState, inputValue, phoneNumberRegex),
    });
};

export const styleForMaterialTextInput = error => {
  return error ? 'formElement-error' : 'formElement';
};

export const getPhoneNumberData = (phoneNumberObject, inputPhoneNumber, phoneNumberRegex) => {
  let phoneObj = { ...phoneNumberObject };
  phoneObj.value = inputPhoneNumber;
  if (
    !inputPhoneNumber ||
    inputPhoneNumber.length < 10 ||
    isNaN(inputPhoneNumber) ||
    !isValidPhoneNumber(inputPhoneNumber, phoneNumberRegex)
  ) {
    phoneObj.error = true;
    phoneObj.errorMessage = translateWithI18Next(TRANSLATE_MAPPING_KEY.MOBILE_ERROR_MESSAGE);
  } else {
    phoneObj.error = false;
    phoneObj.errorMessage = '';
  }
  return phoneObj;
};

export const GetCardDetails = props => {
  const {
    isOpen,
    handleClose,
    tenantId,
    checkCardDetailsModalContent,
    checkCardDetailsModalTitle,
    checkCardDetailsModalButton,
    customerId,
    isMobile,
    phoneNumberRegex,
    giftCardDetails,
  } = props;
  const [buttonDisable, setButtonDisable] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(state => state?.createBalanceReducer?.response);
  const history = useHistory();
  const [submit, isSubmit] = useState(false);
  const [phoneNumberState, setPhoneNumberState] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const { Ellipse } = IMAGE_PATH;

  useEffect(() => {
    dispatch(resetGiftcardCheckBal());
  }, [submit, dispatch]);

  useEffect(() => {
    if (!isEmpty(response)) {
      const status = response?.isSuccess;
      if (status) {
        handleClose();
      } else {
        sessionStorage.setItem(SESSION_STORAGE_KEYS.POST_PAYMENT_TYPE, PURCHASE_TYPE.GET_GIFT_CARD_DETAILS);
        redirectToPaymentFailurePage({ history });
      }
    }
  }, [response, submit, history, handleClose]);

  useEffect(() => {
    const phoneNumberPresent = phoneNumberState.value !== '';
    const phoneLength = phoneNumberState.error === false;
    if (phoneNumberPresent && phoneLength) {
      setButtonDisable(false);
    } else {
      setButtonDisable(true);
    }
  }, [phoneNumberState]);

  const cardKeypressHandler = e => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const submitHandler = e => {
    dispatch(setPWAstorage({ key: 'giftCardDataCustomerDetails', value: giftCardDetails?.customerDetails }));
    setButtonDisable(true);
    isSubmit(true);
    if (phoneNumberState.value !== '') {
      const reqPayload = {
        customerId,
        tenantId: tenantId,
        body: {
          phoneNumber: phoneNumberState.value,
        },
      };
      dispatch(getGiftCardDetails(reqPayload));
    }
  };

  const modalProps = {
    role: 'dialog',
    modalTitleId: 'CheckBalancepopup',
    show: isOpen,
    classNames: isMobile ? 'giftcard-checkbalance-modal' : 'giftcard-getCardDetails-modal',
    showCloseBtn: true,
    closeButtonHandler: handleClose,
    autoFocus: true,
    modalTitle: checkCardDetailsModalTitle,
    closeDataTestId: 'giftcheck-balance',
  };
  return (
    <div className={`giftcardContainer${isMobile ? ' mobile' : ''}`} data-testid='giftcard-checkBal'>
      {isOpen && (
        <Modal {...modalProps}>
          <div className='getDetailsModalHeader'>{checkCardDetailsModalTitle}</div>
          <div className='getDetailsModalContent'>{checkCardDetailsModalContent}</div>
          <div className='getPhoneNumber'>
            <MaterialTextInput
              type='number'
              data-testid='phone-number-testid'
              className={styleForMaterialTextInput(phoneNumberState.error)}
              name='phoneNumber'
              placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY.PHONE_NUMBER_PLACEHOLDER_NOT_REQUIRED)}
              value={phoneNumberState.value}
              onChange={e => updateUserDetails(e, phoneNumberState, setPhoneNumberState, phoneNumberRegex)}
              onKeyPress={e => cardKeypressHandler(e)}
              maxLength={10}
              readOnly={submit}
              onBlur={e => updateUserDetails(e, phoneNumberState, setPhoneNumberState, phoneNumberRegex)}
            />
            <div id='phoneNumber' className={errorStyleForMaterialTextInput(phoneNumberState.error)}>
              {phoneNumberState.error && <img src={Ellipse} alt='error' className={`mr-2`} />}
              <span role='alert'>{phoneNumberState.errorMessage}</span>
            </div>
          </div>
          <div className='buttonGiftModal'>
            <ButtonComp
              data-testid='subm-button'
              className='button blackButton blackBorder save-button'
              onClick={e => submitHandler(e)}
              disabled={buttonDisable}
            >
              {checkCardDetailsModalButton}
            </ButtonComp>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default GetCardDetails;
